const MarkdownIt = require('markdown-it');

// Match DDWN's Markdown dialect (including tables), with raw HTML disabled.
const parser = new MarkdownIt({ html: false });
parser.core.ruler.push('heading_anchors', state => {
  for (let i = 0; i < state.tokens.length; i += 1) {
    if (state.tokens[i].type !== 'heading_open') continue;
    const inline = state.tokens[i + 1];
    const last = inline.children?.[inline.children.length - 1];
    const anchor = last?.type === 'text' && last.content.match(/\s+\{#([a-zA-Z0-9_-]+)\}$/);
    if (anchor) {
      state.tokens[i].attrSet('id', anchor[1]);
      last.content = last.content.slice(0, anchor.index);
    }
  }
});

function renderMarkdown(content = '') {
  return parser.render(content);
}

// Extract the text readers see, preserving words across emphasis and link labels.
function markdownText(content = '') {
  return parser.parse(content, {}).map(token => {
    if (token.type === 'inline') {
      return token.children.map(child => {
        if (child.type === 'softbreak' || child.type === 'hardbreak') return ' ';
        if (['text', 'code_inline', 'image'].includes(child.type)) return child.content;
        return '';
      }).join('');
    }
    if (token.type === 'fence' || token.type === 'code_block') return token.content;
    return '';
  }).filter(Boolean).join(' ');
}

module.exports = { renderMarkdown, markdownText };
